import { getDollarValue, getUfValue } from 'lib/api/cmf';
import { CONVERSION_RATES } from 'lib/consts';
import { useSelector } from 'react-redux';
import { updateConversionRates } from 'services/redux/conversionRatesSlice';
import { RootState } from 'services/redux/store';
import { store } from 'services/redux/store';

export function useConversionRatesState() {
  return useSelector((state: RootState) => state.conversionRates);
}

function isReduxCacheValid(): boolean {
  const state = store.getState();
  const conversionRates = state.conversionRates;

  if (!conversionRates.date) return false;

  const today = new Date().toISOString().split('T')[0];
  return conversionRates.date === today;
}

export function getConversionRatesFromRedux(): { USD: number; UF: number } {
  if (isReduxCacheValid()) {
    const state = store.getState();
    return {
      USD: state.conversionRates.USD,
      UF: state.conversionRates.UF,
    };
  }

  return {
    USD: CONVERSION_RATES.USD,
    UF: CONVERSION_RATES.UF,
  };
}

export function updateConversionRatesInRedux(usdRate: number, ufRate: number) {
  store.dispatch(updateConversionRates({ USD: usdRate, UF: ufRate }));
}

export function useConversionRates(dispatch?: unknown) {
  const fetchAndUpdateRates = async () => {
    if (!dispatch) return;

    if (isReduxCacheValid()) {
      return;
    }

    try {
      const [dollarResponse, ufResponse] = await Promise.all([
        getDollarValue(dispatch),
        getUfValue(dispatch),
      ]);

      const usdRate = dollarResponse?.dolar || CONVERSION_RATES.USD;
      const ufRate = ufResponse?.uf || CONVERSION_RATES.UF;

      updateConversionRatesInRedux(usdRate, ufRate);
    } catch (error) {
      console.error('Error fetching conversion rates:', error);
    }
  };

  return { fetchAndUpdateRates };
}

export function getCurrencyConversionRate(
  quotedCurrency: string,
  conversionRates: { USD: number; UF: number },
): number {
  switch (quotedCurrency.toUpperCase()) {
    case 'CLP':
      return CONVERSION_RATES.CLP;
    case 'USD':
      return conversionRates.USD;
    case 'UF':
      return conversionRates.UF;
    default:
      return CONVERSION_RATES.CLP;
  }
}
